export default __webpack_public_path__ + "static/media/settingsWhite.b09800d7.svg";